<main class="profile-edit-page">
  <div class="top-row">
    <button type="button" class="back-btn" [attr.aria-label]="'profile.backAria' | translate" (click)="goBack()">
      <sz-icon name="arrow-back" [size]="20" />
    </button>
    <sz-brand-block [compact]="true" />
  </div>

  <div class="profile-head">
    <div class="profile-head__kicker">
      <span>{{ 'profileEdit.kicker' | translate }}</span>
    </div>
    <h1 class="profile-head__title">
      {{ 'profileEdit.titleMain' | translate }}
      <span class="profile-head__accent">{{ 'profileEdit.titleAccent' | translate }}</span>
    </h1>
  </div>

  <form class="form" [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
    <div class="field-row">
      <div class="field field--half">
        <div class="field__row">
          <span class="field__label">{{ 'auth.register.fieldFirstName' | translate }}</span>
        </div>
        <sz-text-input
          type="text"
          autocomplete="given-name"
          prefixIcon="user"
          formControlName="firstName"
          [errorText]="firstNameError()" />
      </div>
      <div class="field field--half">
        <div class="field__row">
          <span class="field__label">{{ 'auth.register.fieldLastName' | translate }}</span>
        </div>
        <sz-text-input
          type="text"
          autocomplete="family-name"
          formControlName="lastName"
          [errorText]="lastNameError()" />
      </div>
    </div>

    <div class="field">
      <div class="field__row">
        <span class="field__label">{{ 'auth.common.fieldEmail' | translate }}</span>
      </div>
      <div class="email-readonly">
        <sz-icon name="mail" [size]="18" />
        <span class="email-readonly__value">{{ email() }}</span>
        <span class="email-readonly__lock">
          <sz-icon name="lock" [size]="14" />
        </span>
      </div>
      <div class="field__helper">{{ 'profileEdit.emailReadonlyHelper' | translate }}</div>
    </div>

    @if (errorMessage(); as msg) {
      <p class="auth-error" role="alert">{{ msg }}</p>
    }

    <button
      type="submit"
      class="cta cta--primary"
      [disabled]="loading() || form.invalid"
      [attr.aria-busy]="loading() ? 'true' : null">
      @if (loading()) {
        <span class="spinner" role="status" [attr.aria-label]="'profileEdit.saveAria' | translate"></span>
      } @else {
        <span>{{ 'profileEdit.saveCta' | translate }}</span>
        <sz-icon name="arrow-right" [size]="16" />
      }
    </button>
  </form>

  <div class="danger-zone">
    <div class="danger-zone__label">{{ 'profileEdit.dangerZone' | translate }}</div>
    <button type="button" class="cta cta--destructive" (click)="onDeleteAccount()">
      <sz-icon name="trash" [size]="16" />
      <span>{{ 'profileEdit.deleteAccountCta' | translate }}</span>
    </button>
    <p class="danger-zone__hint">{{ 'profileEdit.deleteAccountHint' | translate }}</p>
  </div>
</main>
